import {
  EditOutlined,
  MessageOutlined,
  DeleteOutlined,
  FileTextOutlined,
  PlusCircleOutlined,
  ColumnWidthOutlined,
} from "@ant-design/icons";

export const ACTION_CONFIG = {
  task_created: {
    label: "Task Created",
    color: "green",
    icon: <PlusCircleOutlined />,
  },
  title_changed: {
    label: "Title Changed",
    color: "blue",
    icon: <EditOutlined />,
  },
  description_changed: {
    label: "Description Changed",
    color: "cyan",
    icon: <FileTextOutlined />,
  },
  column_changed: {
    label: "Column Changed",
    color: "purple",
    icon: <ColumnWidthOutlined />,
  },
  comment_added: {
    label: "Comment Added",
    color: "green",
    icon: <MessageOutlined />,
  },
  comment_edited: {
    label: "Comment Edited",
    color: "orange",
    icon: <EditOutlined />,
  },
  comment_deleted: {
    label: "Comment Deleted",
    color: "red",
    icon: <DeleteOutlined />,
  },
};
